export default __webpack_public_path__ + "static/karolina-1a4ade400b08f1199d0e6d9be978a2e6.jpg";